import React from 'react';
import { setCurrentView } from 'core/utils';
import { ReceivingDetailViewStore } from 'modules/receiving/stores';
import { ReceivingDetailTemplate } from 'themes/modules/receiving/pages';

@setCurrentView(rootStore => new ReceivingDetailViewStore(rootStore), 'receivingDetailViewStore')
class ReceivingDetail extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return <ReceivingDetailTemplate {...this.props} />;
	}
}

export default ReceivingDetail;
